module.exports = __webpack_public_path__ + "img/menu-material.163bd919.svg";